export default "__VITE_ASSET__dfe62493__"